import { useContext } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect
  } from "react-router-dom";
import CreateRoom from 'components/CreateRoom/CreateRoom';
import Game from 'scenes/Game/Game';
import RoomProvider from 'components/Provider/RoomProvider';
import Home from 'scenes/Home/Home';
  
function Navigation(props) {
    const { room } = useContext(RoomProvider);
    return (
        <Router basename='mafiadecuba'>
            <Switch>
                <Route exact path='/'>
                    <Home />
                </Route>
                <Route exact path="/room">
                    { room?.joined ? <Redirect to={`/room/${room.name}`} /> : <CreateRoom /> }
                </Route>    
                <Route path={`/room/*`}>
                    <Game />
                </Route>
            </Switch>    
        </Router>
    );
}

export default Navigation;